/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

 var msnry;

 (function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        $(".mainNav a").click(function(e){
          $(".mainNav li").addClass('inactive');
          $(this).parent("li").removeClass('inactive').addClass('active');
        });

        $('body').on('contextmenu', 'img', function(e){ return false; });

        Waves.attach('.waves', ['waves-button']);
        Waves.init();

        $(".lazy").lazyload({
          effect : "fadeIn",
          effectspeed: 900
        });
        $('.lazy').load(function() {
          masonry_update();
        });

        $(".link").click(function(){
          $(this).addClass("clicked");
        });

        $(".menuToggle").click(function(){
          $(".menu").toggleClass("visible");
          $(this).toggleClass("active");
        });

        
      },
      finalize: function() {

      }
    },
    'home':{
      init: function() {
        $('.slider').bxSlider({
          auto: true,
          adaptiveHeight : true,
          controls : false,
          mode: 'fade',
          speed: 1000
        });
      }
    },
    'tages_und_kunstlicht':{
      init: function() {
        masonry_init();
      }
    },
    'single_project':{
      init: function() {
        $(".toggleDetails").on("click", function(){
          $(".details").slideToggle();
          $(this).toggleClass("active");
        });
      }
    }

  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  
  $( window ).load(masonry_update);

})(jQuery); // Fully reference jQuery after this point.



function masonry_init(){
  msnry = new Masonry(jQuery('.listProjectsMasonry')[0], {
    itemSelector: '.project',
    transitionDuration: 0
  });
  msnry.on( 'layoutComplete', function() {
    jQuery('.listProjectsMasonry').addClass("layoutComplete");
  });
}
function masonry_update(){
  if(msnry){
    msnry.layout();
  }
}
